import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-467edcd4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container long-container"
};
var _hoisted_2 = {
  class: "row"
};
var _hoisted_3 = {
  class: "col-md-4 long-left"
};
var _hoisted_4 = ["src", "alt"];
var _hoisted_5 = {
  class: "text"
};
var _hoisted_6 = {
  class: "col-md-8 long-right"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "应用介绍", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_carousel_item = _resolveComponent("el-carousel-item");

  var _component_el_carousel = _resolveComponent("el-carousel");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_Transition, {
    name: "newsRecommended",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__fadeInLeft"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_carousel, {
        "indicator-position": "outside"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productDetail.imgArr, function (item) {
            return _openBlock(), _createBlock(_component_el_carousel_item, {
              key: item.id
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("img", {
                  src: item.imgUrl,
                  alt: $setup.productTitle
                }, null, 8, _hoisted_4)];
              }),
              _: 2
            }, 1024);
          }), 128))];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_5, [_createElementVNode("h3", null, _toDisplayString($setup.productTitle), 1), _createElementVNode("p", null, _toDisplayString($setup.productDetail.inventory), 1), _createElementVNode("p", null, _toDisplayString($setup.productDetail.specification), 1), _createElementVNode("p", null, _toDisplayString($setup.productDetail.price), 1)])])];
    }),
    _: 1
  }), _createVNode(_Transition, {
    name: "newsRecommended",
    appear: "",
    class: "animate__animated",
    "enter-active-class": "animate__fadeInRight"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("h3", null, _toDisplayString($setup.productDetail.sales), 1), _createElementVNode("h3", null, _toDisplayString($setup.productDetail.sales1), 1), _createElementVNode("h3", null, _toDisplayString($setup.productDetail.sales2), 1), _createElementVNode("h3", null, _toDisplayString($setup.productDetail.sales3), 1), _createElementVNode("h3", null, _toDisplayString($setup.productDetail.sales4), 1)])];
    }),
    _: 1
  })])]);
}